<template>
    <b-modal id="deleteModal-uld" centered hide-footer hide-header size="md" v-model="showReset" @hidden="$emit('close-modal')">
			<div class="d-flex align-items-center justify-content-between">
				<div class="d-flex align-items-center ml-3 mt-3">
					<div>
						<img
							src="../../assets/New Profile/warning-icon.svg"
							alt=""
						/>
					</div>
					<div class="ml-3 pt-2">
						<div class="candash-modal-head-uld">Warning</div>
						<div>
				Are you sure you want to reset the game?
			</div>
					</div>
				</div>
				<div
					class="img-pos pointer rotate-on-hover"
					@click="$emit('close-modal')"
				>
					<img src="../../assets/candidate-documents/docs-x-close.svg" alt="" />
				</div>
			</div>
			

			<div
				class="candash-modal-footer d-flex align-items-center justify-content-end mt-4 border-top-none"
			>
				<b-button
					class="uploadDocs-cancelbtn mr-2"
					@click="$emit('close-modal')"
					>Cancel</b-button
				>
				<div class="uploadDocs-btn position-relative">
					<b-button style="width: 75px"
						:class="buttonLoader ? 'opac-5 text-blue  defaultCursor' : ' pointer'"
						@click="resetGame()"
						>OK</b-button
					>
					<div v-if="buttonLoader" class="loader-pos-new">
						<Loader />
					</div>
				</div>
			</div>
		</b-modal>
</template>
<script>
import Loader from '@/components/fixedcomponents/Loader.vue';
export default {
    data() {
        return {
            buttonLoader: false,
        }
    },
    props: {
        showReset: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Loader,
    },
    methods: {
         resetGame() {
            this.buttonLoader = true;
            this.$emit("resetGame");
        },
    },
}
</script>